import React, { createContext, useState } from "react";

import * as yup from "yup";

import { Sales as SalesQuote } from "../models/sales";
import { JobSubStatus } from "../util/enums";
import { useAppState } from "./StateContext";

interface QuoteContextProps {
  quote?: SalesQuote;
  setQuote: React.Dispatch<React.SetStateAction<SalesQuote | undefined>>;
  handleUpdateQuote: (attribute: string, value: any) => void;
  generalErrors: yup.ValidationError[];
  setGeneralErrors: React.Dispatch<React.SetStateAction<yup.ValidationError[]>>;
  changedOptions?: string[];
  setChangedOptions: React.Dispatch<React.SetStateAction<string[]>>;
}

const QuoteContext = createContext<QuoteContextProps>({} as QuoteContextProps);

interface QuoteProviderProps {
  children: React.ReactChild;
}

const QuoteProvider = ({ children }: QuoteProviderProps) => {
  const { currentUser } = useAppState();
  const [quote, setQuote] = useState<SalesQuote | undefined>({
    jobSubStatus: JobSubStatus.INSPECT,
    user: currentUser,
    userId: currentUser?.id,
    manager: currentUser?.manager,
  });
  const [changedOptions, setChangedOptions] = useState<string[]>([]);
  const [generalErrors, setGeneralErrors] = useState<yup.ValidationError[]>([]);

  const handleUpdateQuote = (attribute: string, value: any) => {
    if (attribute && attribute !== "all") {
      if (!["string", "number", "boolean", "object"].includes(typeof value))
        setQuote((state: any) => ({
          status: "Registered",
          ...state,
          [attribute]: [...value],
        }));
      else
        setQuote((state: any) => ({
          status: "Registered",
          ...state,
          [attribute]: value,
        }));
    } else {
      setQuote({ status: "Registered", ...value });
    }
  };

  return (
    <QuoteContext.Provider
      value={{
        quote,
        setQuote,
        handleUpdateQuote,
        changedOptions,
        setChangedOptions,
        generalErrors,
        setGeneralErrors,
      }}
    >
      {children}
    </QuoteContext.Provider>
  );
};

export { QuoteContext, QuoteProvider };
